import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { CustomOutlet } from '@/components/functional/Link/CustomOutlet';
import { useHotlineClientTermsAgree } from '@/feature/hotline/client/hook/useHotlineClientTermsAgree';
import { HotlineTermsModal } from '@/feature/hotline/component/HotlineTermsModal';
/**
 * 匿名ホットラインクライアント 共通レイアウト
 */
export const HotlineClientLayout = () => {
    const { needsAgreement, onSubmit } = useHotlineClientTermsAgree();
    return (_jsxs(_Fragment, { children: [_jsx(CustomOutlet, {}), needsAgreement && _jsx(HotlineTermsModal, { onSubmit: onSubmit })] }));
};
